/** Stitch / Legal Estate Framework — design tokens (UI only). */
export const stitchColors = {
  background: '#f8f9ff',
  surface: '#f8f9ff',
  surfaceBright: '#f8f9ff',
  surfaceDim: '#d1dbec',
  surfaceContainerLowest: '#ffffff',
  surfaceContainerLow: '#eef4ff',
  surfaceContainer: '#e5eeff',
  surfaceContainerHigh: '#dfe9fa',
  surfaceContainerHighest: '#d9e3f4',
  surfaceVariant: '#d9e3f4',
  onBackground: '#121c28',
  onSurface: '#121c28',
  onSurfaceVariant: '#44474d',
  outline: '#75777e',
  outlineVariant: '#c5c6ce',
  primary: '#04162e',
  onPrimary: '#ffffff',
  primaryContainer: '#1a2b44',
  onPrimaryContainer: '#8292b0',
  inverseSurface: '#27313e',
  inverseOnSurface: '#eaf1ff',
  primaryFixed: '#d5e3ff',
  primaryFixedDim: '#b6c7e7',
  secondary: '#775a19',
  secondaryContainer: '#fed488',
  secondaryFixed: '#ffdea5',
  onSecondaryFixedVariant: '#5d4201',
  tertiary: '#001a1a',
  tertiaryFixed: '#b1eeed',
  tertiaryFixedDim: '#95d1d1',
  onTertiaryFixedVariant: '#074f4f',
  error: '#ba1a1a',
  errorContainer: '#ffdad6',
  surfaceTint: '#4f5f7b',
  /** Side nav canvas (Stitch slate-50) */
  navCanvas: '#f8fafc',
  navBorder: '#e2e8f0',
} as const;

export const stitchRadius = {
  sm: 2,
  md: 4,
  lg: 8,
  xl: 12,
} as const;

export const stitchFonts = {
  headline: '"Newsreader", "Georgia", "Times New Roman", serif',
  body: '"Public Sans", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
} as const;
